import { apiRequestBase } from "./client";
import { env } from "../config/env";

export interface ItemSerial {
  serialId: number;
  binId: number | null;
  serial: string;
}

export interface ItemBatchBin {
  binId: number;
  quantity: number;
}

export interface ItemBatch {
  id: number;
  itemId: number;
  name: string;
  expiryDate: string | null;
  manufactureDate: string | null;
  isActive: boolean;
  totalAvailableQuantity: number;
  binInfo: ItemBatchBin[];
}

export const inventoryApi = {
  getItemSerials: async (params: {
    itemId: number;
    warehouseId: number;
    start: number;
    length: number;
    search?: string;
  }): Promise<{ rows: ItemSerial[]; total: number }> => {
    const response = await apiRequestBase<any>(
      env.inventoryBaseUrl,
      "/ItemSerial/GetAllSerialsForDatatable",
      {
        method: "POST",
        body: {
          query: {
            start: params.start,
            length: params.length,
            search: { value: params.search ?? "" },
          },
          warehouseId: params.warehouseId,
          itemId: params.itemId,
          binId: null,
        },
      },
    );
    const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
    return {
      rows,
      total: Number(response?.data?.recordsFiltered ?? response?.data?.recordsTotal ?? rows.length),
    };
  },

  // Serials sold on a POS order, grouped by item (same call as Biznify's POS return)
  getOrderSerials: async (posOrderId: number): Promise<Array<{ itemId: number; serials: string[] }>> => {
    const response = await apiRequestBase<any>(
      env.inventoryBaseUrl,
      "/ItemSerial/GetAllSerialsByReferenceIdAndTransactionType",
      {
        method: "POST",
        body: {
          referenceId: posOrderId,
          transactionTypeEntityName: "pos",
          isAvailable: true,
        },
      },
    );
    const list = Array.isArray(response?.data) ? response.data : [];
    return list.map((group: any) => ({
      itemId: Number(group?.itemId ?? 0),
      serials: (Array.isArray(group?.serials) ? group.serials : [])
        .map((s: any) => String(typeof s === "string" ? s : s?.serial ?? "").trim())
        .filter(Boolean),
    }));
  },

  getItemBatches: async (params: {
    itemId: number;
    warehouseId: number;
  }): Promise<ItemBatch[]> => {
    const query = new URLSearchParams({
      ItemId: String(params.itemId),
      warehouseId: String(params.warehouseId),
      fetchActives: "true",
    });
    const response = await apiRequestBase<any>(
      env.inventoryBaseUrl,
      `/ItemBatch/getall?${query.toString()}`,
    );
    const list = Array.isArray(response?.data) ? response.data : [];
    return list.map((b: any) => ({
      ...b,
      totalAvailableQuantity: Number(b?.totalAvailableQuantity ?? 0),
      binInfo: Array.isArray(b?.binInfo)
        ? b.binInfo.map((bin: any) => ({
            binId: Number(bin?.binId),
            quantity: Number(bin?.quantity ?? 0),
          }))
        : [],
    }));
  },
};
